import React from 'react';

import { createRoot } from 'react-dom/client';

import { Main } from './main';
import { MockApiUnavailable } from './components/MockApiUnavailable';
import { forgetUnscopedStorage } from './utils/userStorage';

import './i18n';
import './theme.css';
import { mockApi } from './runtimeConfig';

if (process.env.NODE_ENV !== 'production') {
  console.log('development mode');
}

/* what earlier versions remembered for whoever happened to sit at this
   browser — nobody reads it any more (see userStorage) */
forgetUnscopedStorage();

/* With REACT_APP_MOCK_API=true, MSW answers all API calls with mock
   data (src/mocks/); rendering waits until the worker is ready so no
   request slips through. */
async function enableMockApi() {
  if (!mockApi()) {
    return;
  }
  const { worker } = await import('./mocks/browser');
  await worker.start({ onUnhandledRequest: 'bypass' });
}

/* public/index.html carries it; without it there is nothing to render into */
const root = createRoot(document.getElementById('root')!);

/*In React 18+, Strict Mode intentionally runs lifecycle logic twice in development mode.*/
enableMockApi().then(
  () =>
    root.render(
      <React.StrictMode>
        <Main />
      </React.StrictMode>
    ),
  /* Only a build that asked for the mock API gets here, and for it a
     failed worker is not a degradation but a broken release: the
     application would run against REACT_APP_API_BASE_URL, which is
     what happened to a deployment whose service worker was never
     emitted. Say so on the page — a blank one would be worse, and a
     console message alone went unread. */
  (error: Error) => {
    console.error('the mock API could not be started', error);
    root.render(
      <React.StrictMode>
        <MockApiUnavailable error={error} />
      </React.StrictMode>
    );
  }
);
